(() => {
  const ROOT_SELECTOR = '[data-omnee-single-open]';
  const DETAILS_INIT_ATTR = 'data-omnee-accordion-bound';
  const ROOT_INIT_ATTR = 'data-omnee-accordion-root-bound';

  const closeSiblingDetails = (details) => {
    const root = details.closest(ROOT_SELECTOR);
    if (!root || !details.open) return;

    root.querySelectorAll('details[open]').forEach((candidate) => {
      if (candidate !== details) {
        candidate.open = false;
      }
    });
  };

  const bindDetails = (details) => {
    if (!details || details.hasAttribute(DETAILS_INIT_ATTR)) return;

    details.setAttribute(DETAILS_INIT_ATTR, 'true');
    details.addEventListener('toggle', () => {
      closeSiblingDetails(details);
    });
  };

  const initRoot = (root) => {
    if (!root || root.hasAttribute(ROOT_INIT_ATTR)) return;

    root.setAttribute(ROOT_INIT_ATTR, 'true');
    root.querySelectorAll('details').forEach(bindDetails);
    root.querySelectorAll('details[open]').forEach(closeSiblingDetails);
  };

  const initAccordions = (scope = document) => {
    const roots = scope.matches?.(ROOT_SELECTOR) ? [scope] : Array.from(scope.querySelectorAll(ROOT_SELECTOR));
    roots.forEach(initRoot);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAccordions(), { once: true });
  } else {
    initAccordions();
  }

  if (window.Shopify && Shopify.designMode) {
    document.addEventListener('shopify:section:load', (event) => initAccordions(event.target));
  }
})();
